import React, {useCallback, useContext, useEffect, useState} from 'react';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {Props} from '@src/components/Form/FormField';
import ListOfChecklist from '@views/orders/ListOfChecklist';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import app from '@src/helpers/app';
import NoRecordsFound from '@src/components/NoRecordsFound/NoRecordsFound';
import {FormTabsContext} from '@src/contexts/FormTabsContext';
import ChecklistFilter from '@views/orders/ChecklistFilter';

export default function OrderChecklistField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    const [design] = useContext(FormFieldDesignContext);

    type Callback = Required<React.ComponentProps<typeof ListOfChecklist>>['onItemStateChanged'];

    const onChanged = useCallback<Callback>(async (item, state) => {
        await app('http').route('orders.change-checklist-item-state', {
            id: String(props.model?.id)
        }, {
            headers: {'content-type': 'application/json'},
            body: {
                'controller-name': props.formName,
                checklist_item_id: item.id,
                state,
            }
        });
    }, [props.formName, props.model?.id]);

    const checklists = props.modelOptions?.checklists as any;
    const cannotDisplay = !checklists || !props.model?.status_id;

    const {tabName} = props;
    const [tabVisibilityForceState, setTabVisibilityForceState] = useState<boolean | null>(
            cannotDisplay ? false : null
    );
    const tabContext = useContext(FormTabsContext);

    useEffect(() => {
        if (tabName && tabContext && tabVisibilityForceState != null) {
            tabContext.changeVisibility(tabName, tabVisibilityForceState);
        }
    }, [tabVisibilityForceState, tabContext, tabName]);

    if (cannotDisplay) {
        return <NoRecordsFound/>;
    }

    return <ChecklistFilter
            checklists={checklists}
            currentStatusId={props.model?.status_id as number}
            displayOnlyWithType="for-order"
            toggleTabVisibility={setTabVisibilityForceState}
    >{list => {
        return <ListOfChecklist
                checklists={list}
                displayOnlyWithType="for-order"
                currentStatusId={props.model?.status_id as number}
                checkedItems={props.model?.checked_checklists_items}
                canChangeItemsStatePermission="orders@can-change-checklist-items"
                size={design.size}
                onItemStateChanged={onChanged}
                disabled={design.fieldsAreDisabled}
                readonly={design.fieldsAreReadOnly}
        />;
    }}
    </ChecklistFilter>;
}
